// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"0d451a7d","732":"5e1eeaca","977":"3977f422"}[chunkId] + ".chunk.js";
};